<script>
import { mapActions } from "vuex";
import InfiniteAutocomplete from "./InfiniteAutocomplete.vue";

/**
 * 再資源化
 * 処分事業者
 */
export default {
  name: "InfiniteRecycleDisposerAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    disposerId: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: "処分事業者",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: null,
    },
    /**
     * 非表示を除く
     */
    withoutInvisible: {
      type: Boolean,
      default: false,
    },
    withNoneReporting: {
      type: Boolean,
      default: false,
    },
    withNoneSubscribe: {
      type: Boolean,
      default: false,
    },
    ownDisposer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      searchKeyword: null,
      timerId: undefined,
      pageNumber: 0,
      disposers: [],
      pagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableId: null,
    };
  },
  computed: {},
  watch: {
    /**
     * 事業者IDの変更検知
     * @param newValue 事業者ID
     * @param oldValue
     */
    disposerId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadTrader(newValue);
      }
    },
    /**
     * 作業用排出事業場IDの変更検知
     */
    workableId() {
      this.returnValues();
    },
  },
  /**
   * 画面ロード時に呼ばれる.
   * ここで初期設定などを行う.
   */
  created() {
    if (this.disposerId) {
      this.workableId = this.disposerId;
      this.loadTrader(this.workableId);
    } else {
      this.fetchTraderMembers();
    }
  },

  methods: {
    ...mapActions("DriverMasterSearchRecycleDisposer", {
      fetchDisposers: "index",
    }),
    /**
     * 事業者チェンジ コールバック
     * ・事業場の再取得を行う
     */
    changeCallback(arg) {
    },
    /**
     * 事業者クリア コールバック
     */
    clearCallback() {
      this.workableId = null;
      this.$emit("update:values", null);
      this.reloadTraders();
    },
    loadTrader(id) {
      const conditions = {
        target_id: id,
        without_invisible: this.withoutInvisible,
        with_none_reporting: this.withNoneReporting,
        with_none_subscribe: this.withNoneSubscribe,
        own_disposer: this.ownDisposer,
        page: 1,
      };

      this.fetchDisposers({ condition: conditions }).then((response) => {
        this.disposers = response.disposers;
        if (this.disposers.length === 1) {
          this.workableId = this.disposers[0].value;
        } else {
          this.workableId = null;
        }
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      });
    },
    /**
     * 事業者 リロード処理
     */
    reloadTraders() {
      this.searchKeyword = null;
      this.pageNumber = 0;
      this.disposers = [];
      Object.assign( this.$data.pagination, this.$options.data().pagination );
      this.fetchTraderMembers();
    },
    /**
     * 排出事業者オプション取得アクション
     * @returns {Promise<unknown>}
     */
    fetchTraderMembers() {
      this.loading = true;
      const conditions = {
        query: this.traderSearchKeyword,
        without_invisible: this.withoutInvisible,
        with_none_reporting: this.withNoneReporting,
        with_none_subscribe: this.withNoneSubscribe,
        own_disposer: this.ownDisposer,
        page: this.pageNumber,
      };

      this.fetchDisposers({ condition: conditions }).then((response) => {
        this.disposers = this.disposers.concat(response.disposers);
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 排出事業者
     * 次ページ読込
     */
    insectCallback() {
      if (this.pageNumber > 0) {
        this.pageNumber++;
        this.fetchTraderMembers();
      }
    },
    enterKeydownCallback (value) {
      this.pageNumber = 0;
      this.searchKeyword = value;
      this.fetchTraderMembers();
    },

    /**
     * 呼び出し元への戻し
     */
    returnValues() {
      if (this.disposers.length > 0) {
        const object = this.disposers.find((disposer) => disposer.id === this.workableId);
        this.$emit("update:values", object);
      }
    },
  },
};
</script>
<template>
  <div>
    <validation-provider
      v-slot="{ errors }"
      :value="workableId"
      :rules="{ required: required }"
      :class="{ requiredMark: required }"
      :name="label"
    >
      <infinite-autocomplete
        v-model="workableId"
        :classes="classes"
        :disabled="disabled"
        :error-messages="errors"
        :label="label"
        :loading="loading"
        :members="disposers"
        :pagination="pagination"
        :rounded="rounded"
        item-text="label"
        @change="changeCallback"
        @click:clear="clearCallback"
        @insect="insectCallback"
        @keydown:enter="enterKeydownCallback"
      >
        <template v-slot:prepend>
          <slot name="prepend" />
        </template>
        <template v-slot:prepend-inner>
          <slot name="prepend-inner" />
        </template>
        <template v-slot:selection="{ item }">
          <slot name="selection" v-bind:item="item">
            {{ item.text }}
          </slot>
        </template>
        <template v-slot:item="{ item }">
          <slot name="item" v-bind:item="item">
            {{ item.label }}
          </slot>
        </template>
        <template v-slot:append>
          <slot name="append" />
        </template>
        <template v-slot:append-outer>
          <slot name="append-outer" />
        </template>
      </infinite-autocomplete>
    </validation-provider>
  </div>
</template>
